// import our custom CSS
import './css/styles.css';
import $ from 'jquery';
import 'jquery-ui-bundle';
import 'jqdoublescroll';
import 'tablesorter/dist/js/jquery.tablesorter';
import 'jquery.cookie';
import 'micromodal';
// import "bootstrap/dist/js/bootstrap.bundle.js";

import { initializeDialog, } from '@gesis-web/gesis-web-frontend/src/js/gesis-dialog';
import { initializeTabContainers, } from '@gesis-web/gesis-web-frontend/src/js/gesis-tabs';
import { Megamenu,  MegamenuVertical,} from '@gesis-web/gesis-web-frontend/src/js/megamenu.js';
import {
  getMeta,
  getMicrosite,
  getLanguage,
  appendDebug,
  replaceTag,
  showConfetti,
  getXPathForElement,
  getElementByXPath
} from '@gesis-web/gesis-web-frontend/src/js/gesis-helpers.js';

import {
  Search
} from '@gesis-web/gesis-web-frontend/src/js/search.js';

// for DEV to disable missy.js:
import './js/missy.js';

// for DEV to disable missy-extend.js:
import './js/missy-extend.js';
import './js/jquery.base64.min.js';

// create namespace for Gesis Web widget instances
window.GesisWeb = {};
window.getMicrosite = getMicrosite;

document.addEventListener('DOMContentLoaded', function() {
  window.GesisWeb.state = 'initializing';
  window.language = getLanguage();

  const microsite = "missy";

  // initialize Search
  // window.search = new Search();
  window.search = new Search(microsite);
});

// initialize Dialog
window.initializeDialog = initializeDialog;
window.initializeTabContainers = initializeTabContainers;

document.addEventListener('DOMContentLoaded', () => {
  const tabContainersElements = document.getElementsByClassName('tabs');
  const tabContainers = initializeTabContainers(tabContainersElements);

  // initialize Menubuttons / Megamenus
  const menubuttonElements = document.getElementsByClassName('gs_mm_toggle_button');
  window.megamenu = new Megamenu;
  megamenu.init(menubuttonElements);
  
  window.megamenuVertical = new MegamenuVertical;
  megamenuVertical.init();

});
